export const APPOINTMENT_TYPE_GET_REQUESTED = 'APPOINTMENT_TYPE_GET_REQUESTED';
export const APPOINTMENT_TYPE_GET_SUCCEED = 'APPOINTMENT_TYPE_GET_SUCCEED';
export const APPOINTMENT_TYPE_GET_FAILED = 'APPOINTMENT_TYPE_GET_FAILED';

export const APPOINTMENT_SEND_MESSAGE_REQUESTED = 'APPOINTMENT_SEND_MESSAGE_REQUESTED';
export const APPOINTMENT_SEND_MESSAGE_SUCCEED = 'APPOINTMENT_SEND_MESSAGE_SUCCEED';
export const APPOINTMENT_SEND_MESSAGE_FAILED = 'APPOINTMENT_SEND_MESSAGE_FAILED';

export const APPOINTMENT_MARK_REQUESTED = 'APPOINTMENT_MARK_REQUESTED';
export const APPOINTMENT_MARK_SUCCEED = 'APPOINTMENT_MARK_SUCCEED';
export const APPOINTMENT_MARK_FAILED = 'APPOINTMENT_MARK_FAILED';

export const APPOINTMENTS_GET_REQUESTED = 'APPOINTMENTS_GET_REQUESTED';
export const APPOINTMENTS_GET_SUCCEED = 'APPOINTMENTS_GET_SUCCEED';
export const APPOINTMENTS_GET_FAILED = 'APPOINTMENTS_GET_FAILED';

export const APPOINTMENT_GET_REQUESTED = 'APPOINTMENT_GET_REQUESTED';
export const APPOINTMENT_GET_SUCCEED = 'APPOINTMENT_GET_SUCCEED';
export const APPOINTMENT_GET_FAILED = 'APPOINTMENT_GET_FAILED';

export const APPOINTMENT_SUMMARY_REQUESTED = 'APPOINTMENT_SUMMARY_REQUESTED';
export const APPOINTMENT_SUMMARY_SUCCEED = 'APPOINTMENT_SUMMARY_SUCCEED';
export const APPOINTMENT_SUMMARY_FAILED = 'APPOINTMENT_SUMMARY_FAILED';

export const APPOINTMENT_ADD_REQUESTED = 'APPOINTMENT_ADD_REQUESTED';
export const APPOINTMENT_ADD_SUCCEED = 'APPOINTMENT_ADD_SUCCEED';
export const APPOINTMENT_ADD_FAILED = 'APPOINTMENT_ADD_FAILED';

export const APPOINTMENT_RESET_STATE = 'APPOINTMENT_RESET_STATE';

export const APPOINTMENT_TYPE_UPDATE_REQUESTED = 'APPOINTMENT_TYPE_UPDATE_REQUESTED';
export const APPOINTMENT_TYPE_UPDATE_SUCCEED = 'APPOINTMENT_TYPE_UPDATE_SUCCEED';
export const APPOINTMENT_TYPE_UPDATE_FAILED = 'APPOINTMENT_TYPE_UPDATE_FAILED';

export const APPOINTMENT_UPLOAD_FILE_REQUESTED = 'APPOINTMENT_UPLOAD_FILE_REQUESTED';
export const APPOINTMENT_UPLOAD_FILE_SUCCEED = 'APPOINTMENT_UPLOAD_FILE_SUCCEED';
export const APPOINTMENT_UPLOAD_FILE_FAILED = 'APPOINTMENT_UPLOAD_FILE_FAILED';
